export default __webpack_public_path__ + "static/media/gallery-wip-paint_01.edc76c14.jpg";